import { getClientWidth } from 'src/Foundation/Design/platform/app/utils/get-client-width';

interface IItemClickEvent extends Event {
  target: HTMLDivElement;
}

((): void => {
  const activeClass = 'active';
  const activeLinkClass = 'active-link';
  const menuItemActiveClassName = 'active-item';
  const mobileWidthThreshold = 992;
  const topNavigationClass = 'top-menu';
  const siteSelectorLink = `.${topNavigationClass}__siteselector-v3`;
  const regionLinkClass = `${siteSelectorLink}__region__link`;
  const listClass = `${siteSelectorLink}__list`;
  const langItemClassName = `.lang-item`;
  const siteSelectorActiveRegionClassName = 'active-region';
  const siteSelectorListClass = `${listClass}__headline`;

  const langItem: HTMLDivElement | null = document.querySelector(langItemClassName);
  const rootElement: HTMLDivElement | null = document.querySelector(`.${topNavigationClass}`);

  if (!rootElement) {
    return;
  }

  const selector: HTMLDivElement | null = rootElement.querySelector(langItemClassName);
  const selectorHeadlines: NodeListOf<HTMLDivElement> = rootElement.querySelectorAll(siteSelectorListClass);
  const nodesList: NodeListOf<HTMLDivElement> = rootElement.querySelectorAll(regionLinkClass);
  const activeNodeList: NodeListOf<HTMLDivElement> = rootElement.querySelectorAll(listClass);
  const defaultRegion: string | undefined = nodesList.length > 0 ? nodesList[0].dataset.region : undefined;

  if (!selector || !rootElement || !langItem) {
    return;
  }

  /**
   * Foreach implementation for node list.
   * @param elements List of HTML elements.
   * @param action Action to be executed for each HTML element.
   * @remarks Added because of IE11 support. :()
   */
  function forEach<T extends HTMLElement>(elements: NodeListOf<T>, action: (element: T) => void) {
    Array.prototype.forEach.call(elements, action);
  }

  const toggleActiveState = (list: NodeListOf<HTMLDivElement>, index?: string): void => {
    forEach(list, (item: HTMLDivElement) => {
      const { classList } = item;
      if (item.dataset.region === index) {
        classList.add(activeClass);
        classList.add(activeLinkClass);
      } else {
        classList.remove(activeClass);
        classList.remove(activeLinkClass);
      }
    });
  };

  const onListItemClick = (event: IItemClickEvent): void => {
    const { target } = event;
    const regionDiv = target.hasChildNodes() ? target : target.parentElement;
    const isActive = regionDiv.classList.contains(activeClass);
    const region: string | undefined = getClientWidth() < mobileWidthThreshold && isActive ? undefined : regionDiv.dataset.region;

    langItem.classList.add(siteSelectorActiveRegionClassName);
    toggleActiveState(nodesList, region);
    toggleActiveState(activeNodeList, region);
  };

  const onHeadlineClick = (event: IItemClickEvent): void => {
    const { target } = event;

    forEach(activeNodeList, (item: HTMLDivElement) => item.classList.remove(activeClass));
    forEach(nodesList, (item: HTMLDivElement) => item.classList.remove(activeClass));
    langItem.classList.remove(siteSelectorActiveRegionClassName);
    target.classList.add(activeClass);
    rootElement.classList.add(menuItemActiveClassName);
  };

  forEach(nodesList, (item: HTMLDivElement) => item.addEventListener('click', onListItemClick));

  const handleSelection = (): void => {
    if (getClientWidth() < mobileWidthThreshold) {
      return;
    }

    if (selector.querySelectorAll(`${regionLinkClass}.active`).length > 0) {
      return;
    }

    toggleActiveState(nodesList, defaultRegion);
    toggleActiveState(activeNodeList, defaultRegion);
  };

  selector.addEventListener('click', handleSelection);
  forEach(selectorHeadlines, (item: HTMLDivElement) => item.addEventListener('click', onHeadlineClick));

  handleSelection();
})();
